import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon, Gem } from "lucide-react";

const OPTIONS = [
  { id: "dark", label: "Emerald", Icon: Gem },
  { id: "black", label: "Black", Icon: Moon },
  { id: "light", label: "Ivory", Icon: Sun },
];

export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useTheme();
  return (
    <div
      data-testid="theme-toggle"
      role="radiogroup"
      aria-label="Theme"
      className={`flex items-center gap-0.5 rounded-full border border-gold/40 p-0.5 ${className}`}
    >
      {OPTIONS.map(({ id, label, Icon }) => (
        <button
          key={id}
          onClick={() => setTheme(id)}
          role="radio"
          aria-checked={theme === id}
          aria-label={`${label} theme`}
          title={`${label} theme`}
          data-testid={`theme-option-${id}`}
          className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-200 ${
            theme === id ? "bg-gold/20 text-gold" : "text-gold/60 hover:text-gold hover:bg-gold/10"
          }`}
        >
          <Icon className="w-3.5 h-3.5" />
        </button>
      ))}
    </div>
  );
}
